@if (product$ | async) {
<div>
  @if (isTile) {
  <custom-dot-cms-product-tile [layout]="layout()" />
  }
</div>
} @if (loading$ | async) {
<ish-loading />
}
